module.exports = __webpack_public_path__ + "media/images/flags/32/Madagascar-d8ef5cd3cdb83c534e193502a6ae41ee.png";